<template>
  <div>
    <LayoutHeaderWorks
      activeNav="比赛评选"
      :topColor="topColor"
      btnType="top"
      :height="450"
    />
    <div class="container">
            <div style="position:fixed;right:70px;bottom:70px;z-index:999999;" @click="jump()">
              <img src="../../assets/images/match/return.png" alt="" style="width:100px;height:100px"/>
      <br>
      
      <p style="width:100%;text-align:center;">返回列表</p>
      </div>
      <section class="top">
        <div class="top_container">
          <div class="left">
            <h1 v-if="workInfo.id < 10">
              0{{ workInfo.id }}号<span>{{ workInfo.title }}</span>
            </h1>
            <h1 v-else>
              {{ workInfo.id }}号<span>{{ workInfo.title }}</span>
            </h1>
            <h2>已参赛：{{ workInfo.project_name }}</h2>
            <div class="btns">
              
                <div
                  v-if="
                    workInfo.vote_status == undefined ||
                    workInfo.vote_status == 0 &&
					workInfo.is_vote == 1
                  "
                  class="vote"
                  @click="sendTicket()"
                >
                  为TA投票
                </div>
                <div v-if="workInfo.vote_status == 1 && workInfo.is_vote == 1" class="hasVote">已投</div>
                <div
                  v-if="workInfo.grade_status == 0 && inviteStatus"
                  class="vote"
                  @click="comment()"
                >
                  点评
                <div v-if="workInfo.grade_status == 1" class="hasVote">
                  已点评
                </div>
              </div>
              <div class="share" @click="copyUrl()">分享链接</div>
            </div>
          </div>
          <div class="right" >
            <!-- 隐藏作品了的赛事 可对专家显示 但不显示作者名 -->
            <div v-if="workInfo.show_opus == 1" class="creater" ondragstart="return false">
              <img
                v-if="workInfo.author_img_icon_full"
                :src="workInfo.author_img_icon_full"
                alt=""
              />
              <img
                v-else
                src="../../assets/images/default/headPic.png"
                alt=""
              />
              <div>
                <h1
                  style="font-size: 18px; color: #333333"
                  v-if="workInfo.author.length > 1"
                >
                  团队作品
                </h1>
                <h1 style="font-size: 18px; color: #333333" v-else>
                  {{ workInfo.author[0] }}
                </h1>
              </div>
            </div>
            <div class="status">
              <div
                v-if="
                  userInfo.expert_info.status_apply == undefined ||
                  userInfo.expert_info.status_apply == 0
                "
              >
                大众投票：{{ workInfo.ticket }}票
              </div>
              <div v-if="workInfo.grade_type == 1">{{ workInfo.score }}分</div>
              <!-- <div v-if="workInfo.ranking">排名：{{ workInfo.ranking }}</div>
              <div v-else>排名：————</div> -->
            </div>
            <div class="status">
               <div v-if="workInfo.grade_type == 2">专家投票：{{ workInfo.review_ticket }}票</div>
            </div>
          </div>
        </div>
      </section>

      <section class="text">
        <p>
          {{ workInfo.synopsis }}
        </p>
        <!-- && AudioArr.length == 0 && VideoArr.length == 0 -->
        <span
          v-if="
            PicArr.length > 0 
          "
          >内容：组图{{ PicArr.length }}张</span
        >
        
        
      </section>
      <!-- 书画作品 -->
      <!-- && AudioArr.length == 0 && VideoArr.length == 0 -->
      <section
        v-if="PicArr.length > 0 "
        class="pic"
      >
        <ul class="pic_top" ondragstart="return false">
          <viewer :images="[PicArr.annex_path_full]" style="height:100%"> 
          <li
            v-for="(img_item, img_index) in PicArr"
            :key="img_index"
            :class="img_index == current_active ? 'active_top' : ''"
          >
                
                    <img :src="img_item.annex_path_full"   style="max-width:100%;height:100%;">
                    
         
            <!-- <img :src="img_item.annex_path_full" alt="" /> -->
          </li>
           </viewer>
        </ul>
        <div class="pic_bottom" ondragstart="return false">
          <img
            @click="prevImg"
            class="carouselLeft"
            src="../../assets/images/match/bszp-icon-pre@2x.png"
            alt=""
          />
          
          <ul>
            <li
              v-for="(img_item, img_index) in PicArr"
              :class="img_index == current_active ? 'active_bottom' : ''"
              :key="img_index"
              :style="{ left: img_index * 290 + position_times * 290 + 'px' }"
              @click="choseImg(img_index)"
            >
              <img :src="img_item.annex_path_full" alt="" />
            </li>
          </ul>
          <img
            @click="nextImg"
            class="carouselRight"
            src="../../assets/images/match/bszp-icon-next@2x.png"
            alt=""
          />
        </div>
      </section>
      <!-- 音乐作品 -->
      <section class="text">
        <!-- && VideoArr.length === 0 -->
        <span v-if="AudioArr.length > 0 "
          >内容：音乐</span
        >
      </section>
      <!--  && VideoArr.length === 0 -->
      <section
        v-if="AudioArr.length > 0"
        class="music"
      >
        <audio
          @timeupdate="onTimeupdate"
          @loadedmetadata="onLoadedmetadata"
          :src="AudioArr[currentAuidoIndex].annex_path_full"
          ref="audioPlayer"
        ></audio>
        <div class="music_top">
          <div class="left">
            <img
              @click="prevMusic"
              src="../../assets/images/match/bszp-vedio-pre1@2x.png"
              alt=""
            />
            <img @click="playOrPauseMusic" :src="audioBtnImg" alt="" />
            <img
              @click="nextMusic"
              src="../../assets/images/match/bszp-vedio-next1@2x.png"
              alt=""
            />
          </div>
          <div class="middle">
            <h1>
              篇章{{ currentAuidoIndex + 1 }}:{{
                AudioArr[currentAuidoIndex].name
              }}
            </h1>
            <a-slider
              @change="audioSetPercentage"
              v-model="audio.current_percentage"
              :tip-formatter="formatter"
            />
          </div>
          <div class="right">
            <span>{{ audio.currentTime }}</span
            >/<span>{{ audio.maxTime }}</span>
          </div>
        </div>
        <!-- <div v-if="PicArr.length > 0" class="pic">
          <ul class="pic_top">
            <li
              v-for="(img_item, img_index) in PicArr"
              :key="img_index"
              :class="img_index == current_active ? 'active_top' : ''"
            >
              <img :src="img_item.annex_path_full" alt="" />
            </li>
          </ul>
          <div class="pic_bottom">
            <img
              @click="prevImg"
              class="carouselLeft"
              src="../../assets/images/match/bszp-icon-pre@2x.png"
              alt=""
            />
            <ul>
              <li
                v-for="(img_item, img_index) in PicArr"
                :class="img_index == current_active ? 'active_bottom' : ''"
                :key="img_index"
                :style="{ left: img_index * 290 + position_times * 290 + 'px' }"
                @click="choseImg(img_index)"
              >
                <img :src="img_item.annex_path_full" alt=""  />
              </li>
            </ul>
            <img
              @click="nextImg"
              class="carouselRight"
              src="../../assets/images/match/bszp-icon-next@2x.png"
              alt=""
            />
          </div>
        </div> -->
      </section>

      <section class="text">
       <!-- AudioArr.length == 0 &&  -->
        <span v-if="VideoArr.length > 0"
          >内容：视频</span
        >
      </section>
      <!-- AudioArr.length == 0 &&  -->
      <section v-if="VideoArr.length > 0" class="video">
        <video
          :src="VideoArr[currentVideoIndex].annex_path_full"
          controls
        ></video>
        <div class="pic">
          <div class="pic_bottom">
            <img
              @click="prevVideo"
              class="carouselLeft"
              src="../../assets/images/match/bszp-icon-pre@2x.png"
              alt=""
            />
            <ul>
              <li
                v-for="(img_item, img_index) in VideoArr"
                :class="img_index == currentVideoIndex ? 'active_bottom' : ''"
                :key="img_index"
                :style="{ left: img_index * 290 + position_times * 290 + 'px' }"
                @click="choseVideo(img_index)"
              >
                <video :src="VideoArr[img_index].annex_path_full" alt="" />
              </li>
            </ul>
            <img
              @click="nextVideo"
              class="carouselRight"
              src="../../assets/images/match/bszp-icon-next@2x.png"
              alt=""
            />
          </div>
        </div>
      </section>
            <section class="text">
       <!-- AudioArr.length == 0 &&  -->
        <span v-if="PdfArr.length > 0">内容：pdf</span>
        <div v-for="(pdf_item, pdf_index) in PdfArr" :key="pdf_index">
          <span>{{pdf_item.name}}</span>
          <a :href="pdf_item.annex_path_full" target="__blank"><a-button type="primary" html-type="submit" style="margin-left:20px;">查看pdf</a-button></a>
        </div>
      </section>
      <!-- AudioArr.length == 0 &&  -->
      <section v-if="PdfArr.length > 0" class="video">
        <div>

        </div>
      </section>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import WorksServices from "../../xx-vue/services/works";
import Storage from "../../xx-vue/utils/storage";
export default {
  data() {
    return {
      topColor: "",
      navList: ["少年组", "青年组", "中年组"],
      activeNav: "少年组",

      current_active: 0, //当前激活下标
      position_times: 0, //根据此数值动态计算定位left的值
      audioStatus: false, //音频启停状态
      audioBtnImg: require("../../assets/images/match/bszp-vedio-start@2x.png"), //音频按钮图
      audio: {
        currentTime: "00.00", //当前音频时间
        maxTime: 0, //当前音频总时间
        max_num: 0, //总时间数
        current_percentage: 0, //当前百分比
      },
      workInfo: {
        author: [],
      },
      PicArr: [], //图片数组
      AudioArr: [], //音频数组
      VideoArr: [], //视频数组
      PdfArr:[],//pdf数组
      currentAuidoIndex: 0, //当前播放音乐
      currentVideoIndex: 0, //当前播放视频
      userInfo: {
        expert_info: {
          id: undefined,
        },
      },
      inviteStatus: false,
      photo:[],
      PicArrInfo:[]
    };
  },
  mounted() {
    this.initScroll();
    this.initData();
    const userInfo = Storage.getStorage("info");
    if (userInfo) {
      this.userInfo = userInfo;
      console.log(this.userInfo);
      if (this.userInfo.expert_info.id) {
        this.getInviteSuccess();
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
	  //复制到剪切板
	  copyUrl(){
		  var copy=(text)=> {
		      var input = document.createElement('input');
		      input.setAttribute('readonly', 'readonly'); // 防止手机上弹出软键盘
		      input.setAttribute('value', text);
		      document.body.appendChild(input);
		      // input.setSelectionRange(0, 9999);
		      input.select();
		      var res = document.execCommand('copy');
		      document.body.removeChild(input);
		      return res;
		  }
		  var path = window.location.href;
		  copy(path);
		  this.$message.success("链接复制成功！");
	  },
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //更改激活Nav
    changeActive(val) {
      this.activeNav = val;
    },
    //选择图片
    choseImg(index) {
      this.current_active = index;
    },
    //上一张
    prevImg() {
      if (this.current_active <= 0) {
        this.current_active = this.PicArr.length - 1;
        this.position_times = -this.PicArr.length + 1;
      } else {
        this.current_active--;
        this.position_times++;
      }
    },
    //下一张
    nextImg() {
      if (this.current_active >= this.PicArr.length - 1) {
        this.current_active = 0;
        this.position_times = 0;
      } else {
        this.current_active++;
        this.position_times--;
      }
    },
    //播放音频
    playOrPauseMusic() {
      if (this.audioStatus === false) {
        this.audioBtnImg = require("../../assets/images/match/bszp-vedio-stop@2x.png");
        this.audioStatus = true;
        this.$refs.audioPlayer.play();
      } else {
        this.audioBtnImg = require("../../assets/images/match/bszp-vedio-start@2x.png");
        this.audioStatus = false;
        this.$refs.audioPlayer.pause();
      }
    },
    //当前音频时间
    onTimeupdate(res) {
      this.audio.currentTime = this.timeParse(parseInt(res.target.currentTime));
      this.audio.current_percentage =
        (res.target.currentTime / this.audio.max_num) * 100;
    },
    //完整音频时间
    onLoadedmetadata(res) {
      this.audio.maxTime = this.timeParse(parseInt(res.target.duration));
      this.audio.max_num = res.target.duration;
    },
    //格式化时间
    timeParse(value) {
      var newTime = "";
      if (value > -1) {
        var min = Math.floor(value / 60) % 60;
        var sec = value % 60;

        if (min < 10) {
          newTime += "0";
        }
        newTime += min + ":";
        if (sec < 10) {
          newTime += "0";
        }
        newTime += sec;
      }
      return newTime;
    },
    //初始化作品详情
    async initData() {
      const result = await WorksServices.getDetailAsync({
        id: ~~this.$route.query.id,
      });
      this.workInfo = result.data;
      this.workInfo.author = this.workInfo.author.split(",");
      this.PicArr = this.workInfo.opus_annex_list.filter((v) => v.type == 0);
      this.AudioArr = this.workInfo.opus_annex_list.filter((v) => v.type == 2);
      this.VideoArr = this.workInfo.opus_annex_list.filter((v) => v.type == 1);
      this.PdfArr = this.workInfo.opus_annex_list.filter((v) => v.type == 3);
      this.PicArrInfo = ['http://www.res.com/uploads/oc_apply/202108/48/9b0ee51de94a2d92166e88c7dc282a737c686d.jpg','http://www.res.com/uploads/oc_apply/202108/4e/7e4fcb3c415d3669e34ee917e614a3eed3d7fb.jpg']
      
      console.log(this.PicArr, this.AudioArr, this.VideoArr);
      console.log(this.workInfo);
      console.log(this.PdfArr,'pdf');
    },
    //进度条数据
    formatter() {
      return this.audio.currentTime;
    },
    //拖拽进度条
    audioSetPercentage(value) {
      let audio = this.$refs.audioPlayer;
      audio.currentTime = (value / 100) * this.audio.max_num;
    },
    //上一首
    prevMusic() {
      if (this.currentAuidoIndex > 0) {
        this.currentAuidoIndex--;
      } else {
        this.currentAuidoIndex = this.AudioArr.length - 1;
      }

      this.$nextTick((res) => {
        this.$refs.audioPlayer.load();
        this.$refs.audioPlayer.play();
        this.audioBtnImg = require("../../assets/images/match/bszp-vedio-stop@2x.png");
        this.audioStatus = true;
      });
    },
    //下一首
    nextMusic() {
      if (this.currentAuidoIndex < this.AudioArr.length - 1) {
        this.currentAuidoIndex++;
      } else {
        this.currentAuidoIndex = 0;
      }
      this.$nextTick((res) => {
        this.$refs.audioPlayer.load();
        this.$refs.audioPlayer.play();
        this.audioBtnImg = require("../../assets/images/match/bszp-vedio-stop@2x.png");
        this.audioStatus = true;
      });
    },

    //选择视频
    choseVideo(index) {
      this.currentVideoIndex = index;
    },
    //上一个
    prevVideo() {
      if (this.currentVideoIndex <= 0) {
        this.currentVideoIndex = this.VideoArr.length - 1;
        this.position_times = -this.VideoArr.length + 1;
      } else {
        this.currentVideoIndex--;
        this.position_times++;
      }
    },
    //下一个
    nextVideo() {
      if (this.currentVideoIndex >= this.VideoArr.length - 1) {
        this.currentVideoIndex = 0;
        this.position_times = 0;
      } else {
        this.currentVideoIndex++;
        this.position_times--;
      }
    },
    //为TA投票
    async sendTicket() {
      const result = await WorksServices.sendTicketAsyncasync({
        opus_id: this.workInfo.id,
      });
      if (result.code === 200) {
        this.$message.success("投票成功！");
        setTimeout(() => {
          location.reload();
        }, 500);
      }
    },
    //点评
    async comment() {
      this.$router.push(
        `/match/work_grade?id=${this.workInfo.id}&project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
      );
    },
    //获取是否可点评状态
    async getInviteSuccess() {
      const inviteStatus = await WorksServices.getInviteSuccess({
        project_id: ~~this.$route.query.project_id,
        expert_id: this.userInfo.expert_info.id,
      });
      if (inviteStatus.data.count === 0) {
        this.inviteStatus = false;
      } else {
        this.inviteStatus = true;
      }
    },
	        jump(){
      this.$router.push(
                        `/match/match_works?id=${this.$route.query.id}&project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
                  );
    }
	
  },
};
</script>

<style lang="less" scoped>
.container {
  .top {
    margin-bottom: 50px;
    border-bottom: 1px solid #dddddd;
    .top_container {
      width: 1200px;
      margin: 0 auto;
      padding: 42px 0 10px 0;
      display: flex;
      justify-content: space-between;
      .left {
        h1 {
          font-size: 28px;
          color: #bbbbbb;
          margin-bottom: 16px;
          span {
            font-size: 24px;
            color: #333333;
            margin-left: 6px;
            font-weight: normal;
          }
        }
        h2 {
          font-size: 18px;
          color: #333333;
          margin-bottom: 28px;
          font-weight: normal;
        }

        .btns {
          display: flex;
          div {
            width: 88px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
          }

          .vote {
            font-size: 14px;
            color: white;
            background: url("../../assets/images/match/bs-button-normol@2x.png")
              no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }

          .hasVote {
            font-size: 14px;
            color: white;
            text-align: center;
            padding: 4px;
            background: url("../../assets/images/match/bs-button-disable@2x.png")
            no-repeat;
            background-size: 100% 100%;
			line-height: abs(2.3);
            cursor: no-drop;
          }

          & > :first-child {
            margin-right: 18px;
          }

          .clickAble {
            background: url("../../assets/images/match/bs-button-normol@2x.png")
              no-repeat;
            background-size: 100% 100%;
            color: #ffffff;
          }

          .clickEnable {
            background: url("../../assets/images/match/bs-button-disable@2x.png")
              no-repeat;
            background-size: 100% 100%;
            color: #877171;
          }

          .share {
            background: url("../../assets/images/match/bszp-but-02.png")
              no-repeat;
            background-size: 100% 100%;
            color: #a32225;
          }
        }
      }

      .right {
        .creater {
          display: flex;
          align-items: center;
          margin-bottom: 28px;
          img {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            margin-right: 10px;
          }

          div {
            color: #333333;
            font-size: 18px;
          }
        }
        .status {
          display: flex;
          justify-content: space-between;
          color: #a32225;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
  }

  .text {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 40px;
    p {
      width: 510px;
      color: #333333;
      line-height: 32px;
      margin-bottom: 30px;
      font-size: 18px;
    }

    span {
      color: #989898;
    }
  }

  .pic {
    width: 1200px;
    margin: 0 auto;

    .pic_top {
      width: 100%;
      height: 600px;
      position: relative;
      li {
        width: 100%;
        height: 100%;
        list-style: none;
        position: absolute;
        img {
          // width: 100%;
          height: 100%;
        }
      }
    }

    .pic_bottom {
      text-align: center;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 16px 0;
      margin-bottom: 100px;
      ul {
        flex: 1;
        margin-left: 14px;
        margin-right: 14px;
        position: relative;
        overflow: hidden;
        height: 132px;
        li {
          width: 264px;
          height: 132px;
          box-sizing: border-box;
          position: absolute;
          img {
            // width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
        li:not(:nth-child(5)) {
          margin-right: 10px;
        }
      }

      & > img {
        cursor: pointer;
        width: 36px;
        height: 65px;
      }
    }

    .active_bottom {
      border: 1px solid #dedede
    }

    .active_top {
      z-index: 96;
      background-color: black;
      text-align: center;
    }
  }

  .music {
    width: 1200px;
    margin: 0 auto;
    .music_top {
      background-color: #f2f2f2;
      padding: 18px 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .left {
        width: 10%;
        margin-top: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          cursor: pointer;
        }
        & > :nth-child(1) {
          width: 25px;
          height: 22px;
        }
        & > :nth-child(2) {
          width: 28px;
          height: 30px;
        }
        & > :nth-child(3) {
          width: 25px;
          height: 22px;
        }
      }
      .middle {
        width: 70%;
        h1 {
          color: #a32225;
          font-weight: normal;
          font-size: 14px;
          margin-bottom: 5px;
        }
      }
      .right {
        color: #a32225;
        font-size: 18px;
        margin-top: 22px;
        user-select: none;
      }
    }
  }

  .video {
    width: 1200px;
    margin: 0 auto;
    & > video {
      width: 100%;
      height: 600px;
    }

    .pic_bottom {
      video {
        width: 262px;
        height: 130px;
        cursor: pointer;
      }
    }
  }
}
</style>